<template>
  <div class="table-widget">
    <b-table striped hover :items="ld.get(appdata.response, options.module, [])"></b-table>
  </div>
</template>

<script>

import { get } from 'lodash'

export default {

  name: 'TableWidget',
  props: ["appdata", "options"],

  data() {
    return {
      opts: {},
      ld: {
        get: _.get
      },
    }
  }
}
</script>
